import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ScheduledDeliveryState {
  fee: number | null
  daysToDelivery: number | null
}

const initialState: ScheduledDeliveryState = {
  fee: null,
  daysToDelivery: null,
}

export const scheduledDeliverySlice = createSlice({
  name: 'scheduledDelivery',
  initialState,
  reducers: {
    setScheduledDelivery: (
      state,
      action: PayloadAction<{ fee: number; daysToDelivery: number }>
    ) => {
      state.fee = action.payload.fee
      state.daysToDelivery = action.payload.daysToDelivery
    },
    clearScheduledDelivery: () => initialState,
  },
})

export const scheduledDeliveryActions = scheduledDeliverySlice.actions
export const scheduledDeliveryReducer = scheduledDeliverySlice.reducer
